
export const socialUrlBuilder = (platform: string) => {
  switch (platform) {
    case "linkedin":
      return (link: string, title: string, summary?: string) => `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(link)}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(summary)}&source=TravelLocal`;
    case "pinterest":
      return (link: string, imageCaption: string, imageUrl?: string, ) => `http://pinterest.com/pin/create/button/?url=${encodeURIComponent(link)}&media=${encodeURIComponent(imageUrl)}&description=${encodeURIComponent(imageCaption)}`;
    case "twitter":
      return (link: string, message: string) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}&hashtags=TravelLocal&url=${encodeURIComponent(link)}`;
    case "facebook":
      return (link: string, message: string) => `http://www.facebook.com/sharer.php?u=${encodeURIComponent(link)}&t=${encodeURIComponent(message)}`;
    case "whatsapp":
      return (link: string, title: string) => `whatsapp://send?text=${title} ${link}`;
  }
}
